import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { IInputValuesService } from '../../services';
import { BadActorsBase } from '..//badActors/badActorsBase';

class BadValuesTableController extends BadActorsBase implements angular.IComponentController {
    data: any[];

    static $inject = ['$scope', 'inputValuesService'];

    constructor($scope: angular.IScope,
        private _inputValuesService: IInputValuesService) {

        super($scope);
    }

    $onInit() {
        const self = this;
        self.readData();
    }

    readData(guid?: string) {
        this.isLoading = true;


        this._inputValuesService.getNumberOfBadValuesPerTag(guid, 0)
            .then((data) => {
                this.data = data;
                if (this.data) {
                    this.data.forEach((d, i) => {
                        d.status = i;
                    });
                }
            })
            .finally(() => { this.isLoading = false; });
    }
}

export const wtBadValuesTable: ComponentDefinition = {
    componentId: 'wtBadValuesTable',
    controller: BadValuesTableController,
    template: require('./badValuesTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        form: '=',
        selectedGroup: '=',
        selectedItem: '=',
        isEditMode: '=',
        isSelectionPrevented: '='
    }
};